import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import imageCompression from 'browser-image-compression';
import { useLocation } from "react-router-dom";

const optionIrAttached = [
  { value: "", label: "Select Option" },
  { value: "-1", label: "Yes" },
  { value: "1", label: "No" },
];

const optionSpeedTest = [
  { value: "", label: "Please Select Speed test" },
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

const optionIP = [
  { value: "", label: "Please Select IP" },
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

const optionMRTG = [
  { value: "", label: "Please Select MRTG" },
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

const optionDns = [
  { value: "", label: "Please Select DNS" },
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];
const optionSelfcarePortal = [
  { value: "", label: "Please Select Education Customer" },
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];
const optionAntivirus = [
  { value: "", label: "Please Select Virus" },
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

const optionCpMacShare = [
  { value: "Completed", label: "Completed" },
  { value: "", label: "Select CPE Type" },
];
const yesNoOptions = [
  { value: "", label: "Select Option" },
  { value: "111260000", label: "Yes" },
  { value: "111260001", label: "No" },
  // { value: "111260002", label: "NA" },
];
const InstallationIR = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
    inputFocused: {
      boxShadow: "none",
      fontSize: "14px",
    },
  };
  const [loading, setLoading] = useState(false);
  const [loaders, setLoaders] = useState(false);
  const [activeForm, setActiveForm] = useState("form1");
  const [attachForm, setAttachForm] = useState("");
  const [irInfo, setIRInfo] = useState([]);
  const [irAttache, setIrAttache] = useState("");
  const [speedTest, setSpeedTest] = useState(optionSpeedTest[0]);
  const [selectIP, setSelectIP] = useState(optionIP[0]);
  const [selectMRTG, setSelectMRTG] = useState(optionMRTG[0]);
  const [selectDns, setSelectDns] = useState(optionDns[0]);
  const [selectSelfcarePortal, setSelectSelfcarePortal] = useState(
    optionSelfcarePortal[0]
  );
  // NEW: Contact Person fields
  const [cpName, setCpName] = useState("");
  const [cpMobile, setCpMobile] = useState("");

  const [selectAntivirus, setSelectAntivirus] = useState(optionAntivirus[0]);
  const [holdCategories, setHoldCategories] = useState([]);
  const [selectHoldCategory, setSelectHoldCategory] = useState(null);
  const [fileName, setFileName] = useState("");
  const [base64Content, setBase64Content] = useState("");
  const [documentfile, setDocumentfile] = useState("");
  const [cpMacShare, setCpMacShare] = useState("");
  const [consumptionStatus, setConsumptionStatus] = useState("");
  // Installation Parameters state
  const [educatedOnMRTG, setEducatedOnMRTG] = useState(yesNoOptions[0]);
  const [educatedOnMRTGImg, setEducatedOnMRTGImg] = useState({ fileNameWithExtension: "", fileContent: "" });
  const [informedCustomerContentionRatio, setInformedCustomerContentionRatio] = useState(yesNoOptions[0]);
  const [pastedStickerOnCPE, setPastedStickerOnCPE] = useState(yesNoOptions[0]);
  const [educatedCustomerWelcomeMailer, setEducatedCustomerWelcomeMailer] = useState(yesNoOptions[0]);
  const [educatedCustomerOnFLTSteps, setEducatedCustomerOnFLTSteps] = useState(yesNoOptions[0]);
  // const [mountRackOnWallProperHardware, setMountRackOnWallProperHardware] = useState(yesNoOptions[0]);
  const [mountRackImage, setMountRackImage] = useState({ fileNameWithExtension: "", fileContent: "" });
  // const [mountDLinkSwitchONT, setMountDLinkSwitchONT] = useState(yesNoOptions[0]);
  const [mountDLinkImage, setMountDLinkImage] = useState({ fileNameWithExtension: "", fileContent: "" });
  const [dropOFCCableFTB, setDropOFCCableFTB] = useState(yesNoOptions[0]);
  const [mountRackOnWallProperHardware, setMountRackOnWallProperHardware] = useState(yesNoOptions[1]); // Yes
  const [mountDLinkSwitchONT, setMountDLinkSwitchONT] = useState(yesNoOptions[1]); // Yes
  const [noSharpBendDropCableOFCcable, setNoSharpBendDropCableOFCcable] = useState(yesNoOptions[0]);
  const [pClampFixedAfterEveryMeters, setPClampFixedAfterEveryMeters] = useState(yesNoOptions[0]);
  const [allMaterialWiringCompletion, setAllMaterialWiringCompletion] = useState(yesNoOptions[0]);
  const [ONTProvisioning, setONTProvisioning] = useState(yesNoOptions[0]);
  const [SwitchProvisioning, setSwitchProvisioning] = useState(yesNoOptions[0]);
  const [redundancyFailoverCheck, setRedundancyFailoverCheck] = useState(yesNoOptions[0]);
  const [redundancyFailoverImage, setRedundancyFailoverImage] = useState({ fileNameWithExtension: "", fileContent: "" });
  const [position, setPosition] = useState({ latitude: "", longitude: "" });
  const [productSegment, setProductSegment] = useState("");

  const getLocation = () => {
    // Check if served over HTTPS (geolocation doesn't work over HTTP in production)
    if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
      toast.error("Location access requires HTTPS. Please use a secure connection.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
      });
      return;
    }

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setPosition({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
            message: "Location Captured",
          });
        },
        (error) => {
          console.error("Geolocation error:", error);
          toast.error("Unable to retrieve location. Please check browser permissions.", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
          });
        }
      );
    } else {
      toast.warning("Geolocation is not supported by this browser.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
      });
    }
  };

  // Log updated location when it changes
  useEffect(() => {
    if (position.latitude && position.longitude) {
      //    console.log("Updated position:", position);
    }
  }, [position]);

  useEffect(() => {
    getLocation();
  }, []);

  const callCompareAPI = async (imageBase64) => {
    const currentDate = new Date();
    const toDate = currentDate.getFullYear() + '-' +
    String(currentDate.getMonth() + 1).padStart(2, '0') + '-' +
    String(currentDate.getDate()).padStart(2, '0');
    console.log("toDate", toDate);
    
    const payload = {
      canId: sessionStorage.getItem("CanId") || "",
      // srNumber: "",
      ProductSegment : productSegment ? productSegment :"",
      Source : "FFA",
      dateTime: toDate,
      Latitude: position.latitude ? `${position.latitude}` : "",
      Longitude: position.longitude ? `${position.longitude}` : "",
      image_base64: imageBase64,
    };

    try {
      const res = await fetch("https://oneml.spectra.co/api/installation/compare", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(() => null);
      console.log("🔍 compare API status:", res.status, "response:", data);
      return { ok: res.ok, data };
    } catch (err) {
      console.error("compare API error:", err);
      return { ok: false, data: null };
    }
  };
  // helper to read & compress an image into base64
  // const handleImageUpload = async (e, setter) => {
  //   const file = e.target.files[0];
  //   if (!file) return;
  //   const options = { maxSizeMB: 1, maxWidthOrHeight: 1920, useWebWorker: true };
  //   const compressed = await imageCompression(file, options);
  //   const reader = new FileReader();
  //   reader.onload = (evt) => {
  //     const base64 = evt.target.result.split(';base64,')[1];
  //     setter({ fileNameWithExtension: file.name, fileContent: base64 });
  //   };
  //   reader.readAsDataURL(compressed);
  // };

  const handleImageUpload = async (e, setter) => {
    const file = e.target.files[0];
    if (!file) return;

    // start global loader
    setLoading(true);

    try {
      const options = { maxSizeMB: 1, maxWidthOrHeight: 1920, useWebWorker: true };
      const compressed = await imageCompression(file, options);
      const reader = new FileReader();

      reader.onload = async (evt) => {
        const base64 = evt.target.result.split(";base64,")[1];

        // 1) update the specific image state (e.g., educatedOnMRTGImg, mountRackImage, …)
        setter({ fileNameWithExtension: file.name, fileContent: base64 });

        // 2) call compare API and keep loader running until it completes
        const { ok, data } = await callCompareAPI(base64);

        if (ok && data && data.code === 200 && data.status === "success") {
          toast.success("Image verified successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        } else {
          const errorMessage = data?.message || "Compare API failed";
          toast.error(errorMessage, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }

        // stop loader after API completes
        setLoading(false);
      };

      reader.readAsDataURL(compressed);
    } catch (error) {
      console.error("Error compressing/reading image:", error);
      toast.error("Image processing failed", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setLoading(false);
    }
  };

  // Save handler that fires both APIs
  // const handleSaveInstallationParams = async () => {
  //   const apiUrl = process.env.REACT_APP_API_URL;
  //   const irGuid = sessionStorage.getItem('irId');

  //   // first payload
  //   const checklistPayload = {
  //     Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //     Action: "installationCheckList",
  //     IRGUID: irGuid,
  //     EducatedonMRTG: educatedOnMRTG.value,
  //     InformedCustomerContentionRatio: informedCustomerContentionRatio.value,
  //     PastedStickerOnCPE: pastedStickerOnCPE.value,
  //     EducatedCustomerWelcomeMailer: educatedCustomerWelcomeMailer.value,
  //     EducatedCustomerOnFLTSteps: educatedCustomerOnFLTSteps.value,
  //     MountRackOnWallProperHardware: mountRackOnWallProperHardware.value,
  //     MountDLinkSwitchONT: mountDLinkSwitchONT.value,
  //     DropOFCCableFTB: dropOFCCableFTB.value,
  //     NoSharpBendDropCableOFCcable: noSharpBendDropCableOFCcable.value,
  //     PclampfixedAfterEverymeters: pClampFixedAfterEveryMeters.value,
  //     AllMaterialWiringCompletion: allMaterialWiringCompletion.value,
  //     ONTProvisioning: ONTProvisioning.value,
  //     SwitchProvisioning: SwitchProvisioning.value,
  //     RedundancyFailoverCheck: redundancyFailoverCheck.value,
  //     EducatedonMRTGImg: educatedOnMRTGImg,
  //     MountRackImage: mountRackImage,
  //     MountDLinkImage: mountDLinkImage,
  //     RedundancyFailoverImage: redundancyFailoverImage,
  //     // EXACT keys with trailing spaces as requested
  //     "CPName ": (cpName || "").trim(),
  //     "CPMobileNumber ": (cpMobile || "").trim(),

  //   };

  //   // second payload
  //   const updatePayload = {
  //     Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //     Action: "updateIRInstallation",
  //     IRguid: irGuid,
  //     AntiVirus: selectAntivirus.value,
  //     SelfCare: selectSelfcarePortal.value,
  //     DNS: selectDns.value,
  //     MRTG: selectMRTG.value,
  //     IP: selectIP.value,
  //     Speed: speedTest.value,
  //     SpeedMsd: "",
  //     OntConversion: ""
  //   };

  //   try {
  //     setLoading(true);
  //     await fetch(apiUrl, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(checklistPayload)
  //     });
  //     await fetch(apiUrl, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(updatePayload)
  //     });
  //     toast.success("Installation parameters saved successfully", { position: toast.POSITION.BOTTOM_CENTER });
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Failed to save installation parameters", { position: toast.POSITION.BOTTOM_CENTER });
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const handleSaveInstallationParams = async () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const irGuid = sessionStorage.getItem("irId");
    const canId = sessionStorage.getItem("CanId");

    if (!mountRackImage.fileContent) {
      toast.warning("Please upload image for 'Mount Rack on Wall with proper hardware'", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
 
    if (!mountDLinkImage.fileContent) {
      toast.warning("Please upload image for 'Mount D-Link/Switch/ONT at suitable height'", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    const checklistPayload = {
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      Action: "installationCheckList",
      IRGUID: irGuid,
      EducatedonMRTG: educatedOnMRTG.value,
      InformedCustomerContentionRatio: informedCustomerContentionRatio.value,
      PastedStickerOnCPE: pastedStickerOnCPE.value,
      EducatedCustomerWelcomeMailer: educatedCustomerWelcomeMailer.value,
      EducatedCustomerOnFLTSteps: educatedCustomerOnFLTSteps.value,
      MountRackOnWallProperHardware: mountRackOnWallProperHardware.value,
      MountDLinkSwitchONT: mountDLinkSwitchONT.value,
      DropOFCCableFTB: dropOFCCableFTB.value,
      NoSharpBendDropCableOFCcable: noSharpBendDropCableOFCcable.value,
      PclampfixedAfterEverymeters: pClampFixedAfterEveryMeters.value,
      AllMaterialWiringCompletion: allMaterialWiringCompletion.value,
      ONTProvisioning: ONTProvisioning.value,
      SwitchProvisioning: SwitchProvisioning.value,
      RedundancyFailoverCheck: redundancyFailoverCheck.value,
      EducatedonMRTGImg: educatedOnMRTGImg,
      MountRackImage: mountRackImage,
      MountDLinkImage: mountDLinkImage,
      RedundancyFailoverImage: redundancyFailoverImage,
      "CPName ": (cpName || "").trim(),
      "CPMobileNumber ": (cpMobile || "").trim(),
    };

    const updatePayload = {
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      Action: "updateIRInstallation",
      IRguid: irGuid,
      AntiVirus: selectAntivirus.value,
      SelfCare: selectSelfcarePortal.value,
      DNS: selectDns.value,
      MRTG: selectMRTG.value,
      IP: selectIP.value,
      Speed: speedTest.value,
      SpeedMsd: "",
      OntConversion: "",
    };

    const insertImagePayload = {
      canId: canId,
      IRGUID: irGuid,
      EducatedonMRTGImg: educatedOnMRTGImg,
      MountRackImage: mountRackImage,
      MountDLinkImage: mountDLinkImage,
      RedundancyImage: redundancyFailoverImage,
    };

    try {
      setLoading(true);

      const checklistRes = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(checklistPayload),
      });
      const checklistData = await checklistRes.json().catch(() => null);
      console.log("📋 installationCheckList → Status:", checklistRes.status);
      console.log("📋 installationCheckList → Response:", checklistData);

      if (!checklistRes.ok) throw new Error("installationCheckList failed");

      try {
        const updateRes = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updatePayload),
        });
        const updateData = await updateRes.json().catch(() => null);
        console.log("🔧 updateIRInstallation → Status:", updateRes.status);
        console.log("🔧 updateIRInstallation → Response:", updateData);
      } catch (updateErr) {
        console.warn("⚠️ updateIRInstallation failed:", updateErr);
      }

      const imageApiUrl =
        "https://oneml.spectra.co/api/installation/insert-image-data";
      const imageRes = await fetch(imageApiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(insertImagePayload),
      });
      const imageData = await imageRes.json().catch(() => null);
      console.log("🖼️ insert-image-data → Status:", imageRes.status);
      console.log("🖼️ insert-image-data → Response:", imageData);

      toast.success("Installation parameters saved successfully", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } catch (err) {
      console.error("❌ Error in handleSaveInstallationParams:", err);
      toast.error("Failed to save installation parameters", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } finally {
      setLoading(false);
    }
  };

  const redirectToAddEqup = () => {
    navigate("/addEquipmentIR");
  };

  const navigateToEditEquip = (dataArray) => {
    navigate('/editEquipmentConsumptionIR', { state: { data: dataArray } });
  };


  const navigateToEditItem = (dataArray) => {
    navigate('/EditItemConsumptionIR', { state: { data: dataArray } });
  };

  const navigateToServiceConsumption = (dataArray) => {
    navigate('/editServiceConsumptionIR', { state: { data: dataArray } });
  };

  const redirectServiceConsumptionIR = () => {
    navigate("/ServiceConsumptionIR")
  }

  const handleSelectIrAttache = (irAttache) => {
    setIrAttache(irAttache);
  };
  const handleSelectSpeedTest = (selectSpeedTest) => {
    setSpeedTest(selectSpeedTest);
  };
  const handleSelectIP = (selectIP) => {
    setSelectIP(selectIP);
  };
  const handleSelectMRTG = (selectMrtg) => {
    setSelectMRTG(selectMrtg);
  };
  const handleSelectDns = (selectDns) => {
    setSelectDns(selectDns);
  };
  const handleSelectSelfcarePortal = (selectSelfcarePortal) => {
    setSelectSelfcarePortal(selectSelfcarePortal);
  };
  const handleSelectAntivirus = (selectAntivirus) => {
    setSelectAntivirus(selectAntivirus);
  };

  const handleSelectCpMacShare = (selectCpMac) => {
    setCpMacShare(selectCpMac);
  };

  const handleAttachmentClick = async (formId) => {
    setAttachForm((prevActiveBox) => prevActiveBox === formId ? null : formId);
    setActiveForm('');
    try {
      setLoaders(true);
      toast.warning("Please wait...", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "getWCRIRDocument",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        irId: sessionStorage.getItem("irId"),
        wcrId: "",
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      // console.log("API Response:", data);

      if (data.Response.StatusCode === 200) {
        setDocumentfile(data.Response.Data);
        setLoaders(false);
      } else {
        // const errorMessage = data && data.Response && data.Response.Message;
        //   console.log("errorMessage",errorMessage);
        toast.warning("Please wait...", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 500,
        });
        setLoaders(false);
      }
    } catch (error) {
      console.error("Error fetching hold categories:", error);
    }
  };

  useEffect(() => {
    const fetchHoldCategories = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "WCRholdCategories",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const data = await response.json();
        //   console.log("API Response:", data);
        if (data.Status === "Success") {
          const categories = data.Response.WCR_Hold_Category.map(
            (category) => ({
              value: category.ID,
              label: category.Category,
            })
          );
          setHoldCategories(categories);
        } else {
          console.error("Failed to fetch hold categories:", response.status);
        }
      } catch (error) {
        console.error("Error fetching hold categories:", error);
      }
    };

    fetchHoldCategories();
  }, []);

  const handleSelectHoldCategory = (selectedOption) => {
    setSelectHoldCategory(selectedOption);
  };

  const [userIrData, setUserIrData] = useState({
    installationdate: "",
    installationCode: "",
    holdReason: "",
    remark: "",
  });

  const handleChange = (e) => {
    // console.log(e.target.name, e.target.value);
    setUserIrData({ ...userIrData, [e.target.name]: e.target.value });
  };

  const convertDateFormat = (dateString) => {
    // Split the date string into day, month, and year
    const [day, month, year] = dateString.split('/');
    // Assemble the date in the format "yyyy-mm-dd"
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };


  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = `${today.getMonth() + 1}`.padStart(2, "0");
    const day = `${today.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };



  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "ffaGetIRInfo",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          CanId: sessionStorage.getItem("CanId"),
          OrderId: sessionStorage.getItem("OrderID"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          //   console.log("API Response:", result);
          setLoading(false);
          if (
            result &&
            result.Response &&
            result.Response.Status !== "Failure"
          ) {
            // console.log("Actual Data:", result.Response);
            sessionStorage.setItem('irId', result.Response.IR.IRGUID);
            setProductSegment(result?.Response?.IR?.ProductSegment);
            setUserIrData({
              installationCode: result.Response.Engineer.OTP ? result.Response.Engineer.OTP : "",
              installationdate: result.Response.Engineer.InstallationDate ? convertDateFormat(result.Response.Engineer.InstallationDate) : "",
              holdReason: result.Response.Engineer.HoldReason ? result.Response.Engineer.HoldReason : "",
            });
            setConsumptionStatus(result.Response.IR.ConsumptionStatus);
            if (result.Response.General && result.Response.General.IRAttached) {
              setIrAttache({
                label: result.Response.General.IRAttached,
                value: result.Response.General.IRAttached,
              });
            }
            setSpeedTest({
              label: result.Response.InstallationQty.Speed,
              value: result.Response.InstallationQty.Speed,
            });
            setSelectIP({
              label: result.Response.InstallationQty.IP,
              value: result.Response.InstallationQty.IP,
            });
            setSelectMRTG({
              label: result.Response.InstallationQty.IP,
              value: result.Response.InstallationQty.IP,
            });
            setSelectDns({
              label: result.Response.InstallationQty.MRTG,
              value: result.Response.InstallationQty.MRTG,
            });
            setSelectSelfcarePortal({
              label: result.Response.InstallationQty.SelfCare,
              value: result.Response.InstallationQty.SelfCare,
            });
            setSelectAntivirus({
              label: result.Response.InstallationQty.AntiVirus,
              value: result.Response.InstallationQty.AntiVirus,
            });
            setCpMacShare({
              label: result.Response.IR.MACShared,
              value: result.Response.IR.MACShared,
            });

            let irinfo = [];
            irinfo.push(result.Response);
            setIRInfo(irinfo);
            // console.log("ffaGetIRInfo", result.Response, "irinfo", irinfo);
          } else {
            const errorMessage =
              result && result.Response && result.Response.Message;
            // console.log("errorMessage", errorMessage);
            //   toast.warning(`${errorMessage}`, {
            //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
            // });
          }
        } else {
          console.error("Error fetching data:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        //   setLoading(false);
      }
    };
    fetchData();
  }, []);

  // useEffect(() => {
  //   const fetchHoldCategories = async () => {
  //     try {
  //       setLoaders(true);
  //       const apiUrl = process.env.REACT_APP_API_URL;
  //       const requestData = {
  //         Action: "getWCRIRDocument",
  //         Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         irId: sessionStorage.getItem("irId"),
  //         wcrId: "",
  //       };
  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestData),
  //       });
  //       const data = await response.json();
  //       console.log("API Response:", data);

  //       if (data.Response.StatusCode === 200) {
  //         setDocumentfile(data.Response.Data);
  //         setLoaders(false);
  //       }else{
  //         // const errorMessage = data && data.Response && data.Response.Message;
  //     //   console.log("errorMessage",errorMessage);
  //       toast.warning("Please wait...", {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         autoClose: 500,
  //       });
  //       setLoaders(false);
  //     }
  //     } catch (error) {
  //       console.error("Error fetching hold categories:", error);
  //     }
  //   };

  //   fetchHoldCategories();
  // }, []);

  const openCamera = () => {
    document.getElementById("cameraFileInput").click();
  };

  const isValidBase64 = (base64String) => {
    // Regular expression to check if the string is valid base64
    const base64Regex = /^[a-zA-Z0-9+/]*={0,2}$/;
    return base64Regex.test(base64String);
  };

  const handleDownload = (fileName, base64String) => {
    try {
      // console.log('Downloading file:', fileName, base64String); // Add logging here
      if (
        !base64String ||
        typeof base64String !== "string" ||
        !isValidBase64(base64String)
      ) {
        throw new Error(
          "Base64 string is missing, invalid, or not properly encoded."
        );
      }
      // Create blob from base64 string
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray]);
      // Create download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      // Append link to the body, trigger download, and remove link
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    // Set compression options
    const options = {
      maxSizeMB: 1,            // Maximum file size in MB
      maxWidthOrHeight: 1920,  // Max width or height
      useWebWorker: true,      // Use web worker for faster compression
    };
    // Compress the image file
    const compressedFile = await imageCompression(file, options);
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result.split(";base64,")[1];
      // console.log('File content:', base64String); // Log base64 content
      const inputText = "Picture Captured";
      setFileName(inputText); // Set the input text
      setBase64Content(base64String); // Set the base64 content
    };
    reader.readAsDataURL(compressedFile);
  };

  const navigate = useNavigate();
  const redirectinstallProvision = () => {
    navigate("/installationprovisioning");
  };
  const handleIconClick = (formId) => {
    setAttachForm('')
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectinstallProvision}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">IR</span>
        </div>
      </div>
      {/* ************Header end************ */}
      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div>
          <div className="container-fluid irwcr-container text-center">
            <span className="wcr-status">IR Status : {sessionStorage.getItem('StatusofReport')}</span>
            <br />
            <span className="wcr-status">Consumption Status : {consumptionStatus}</span>
            <hr />
            <div className="container">
              <button
                type="submit"
                className="btn text-light w-100 add-item-btn mx-auto"
              // onClick=""
              >
                RESEND OTP
              </button>
            </div>
            <hr />
          </div>

          <div className="container-fluid">
            {/* **************Customer Details toggle******************* */}
            <div
              className="contact-toggle"
              onClick={() => handleIconClick("form1")}
            >
              <span className="toggle-text">Customer Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************Customer Details toggle******************* */}
            {activeForm === "form1" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form1"
              >
                {/**********Customer Details******** */}
                <form className="contact-form p-2 m-1">
                  <p className="wcr-customer-detail">
                    Customer business segment:{" "}
                    {irInfo.length > 0 && irInfo[0].IR
                      ? irInfo[0].IR.BusinessSegment
                      : ""}
                  </p>
                  {/* <p className='ir-customer-detail'>Customer business segment : {irInfo[0] ? irInfo[0].IR.BusinessSegment : ""}</p> */}
                  <p className="ir-customer-detail">
                    POD:{" "}
                    {irInfo.length > 0 && irInfo[0].IR ? irInfo[0].IR.Pod : ""}
                  </p>
                  <p className="ir-customer-detail">
                    Product:{" "}
                    {irInfo.length > 0 && irInfo[0].IR
                      ? irInfo[0].IR.Product
                      : ""}
                  </p>
                  <p className="ir-customer-detail">
                    Installation Date:{" "}
                    {irInfo.length > 0 && irInfo[0].IR
                      ? irInfo[0].IR.Installationdate
                      : ""}
                  </p>
                </form>
              </div>
            )}

            {/* **************Item Consumption Details toggle******************* */}
            <div
              className="contact-toggle  mt-3"
              onClick={() => handleIconClick("form2")}
            >
              <span className="toggle-text">Item Consumption Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************Item Consumption Details toggle******************* */}
            {activeForm === "form2" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form2"
              >
                {/**********Item Consumption Details******** */}
                <form className="contact-form p-2">
                  {irInfo?.map((ir, index) => (
                    <div className="form-floating" key={index}>
                      {ir?.itemConsumtionList?.map((item, itemIndex) => (
                        <div className="col" key={itemIndex}>
                          <div className="card mb-3">
                            <div className="m-2 card-data ">
                              <div>
                                <p className="wcr-card-text">
                                  Item : {item.Item}
                                </p>
                                <p className="wcr-card-text">
                                  SubItem : {item.SubItem}{" "}
                                </p>
                                <p className="wcr-card-text">
                                  ItemType : {item.ItemType}{" "}
                                </p>
                                <p className="wcr-card-text">
                                  ItemCode : {item.ItemCode}{" "}
                                </p>
                                <p className="wcr-card-text">
                                  Serial Num : {item.SerialNumber}{" "}
                                </p>

                                <div className="row">
                                  <div className=" col-6 text-center ">
                                    <button
                                      type="submit"
                                      className="btn text-light edit-wcr-btn edit-btn rounded-pill"
                                      onClick={() => navigateToEditItem(item)}
                                    >
                                      EDIT
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      type="submit"
                                      className="btn text-light bg-dark delete-btn rounded-pill"
                                    //  onClick={redirectToWCR}
                                    >
                                      DELETE
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </form>
              </div>
            )}

            {/* **************Equipment Details toggle******************* */}
            <div
              className="contact-toggle  mt-3"
              onClick={() => handleIconClick("form3")}
            >
              <span className="toggle-text">Equipment Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************Equipment Details toggle******************* */}
            {activeForm === "form3" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form3"
              >
                <div className="col text-center ">
                  <button
                    type="submit"
                    className="btn text-light mt-2 mb-3 w-75 add-item-btn mx-auto"

                    onClick={redirectToAddEqup}

                  >
                    ADD EQUIPMENT
                  </button>
                </div>
                {/**********Equipment Details******** */}
                <form className="contact-form p-2">
                  {irInfo?.map((ir, index) => (
                    <div className="form-floating" key={index}>
                      {ir?.InstallationItemList?.map((item, itemIndex) => (
                        <div className="col" key={itemIndex}>
                          <div className="card mb-3">
                            <div className="m-2 card-data ">
                              <div>
                                <p className="wcr-card-text">
                                  Item : {item.Item}
                                </p>
                                <p className="wcr-card-text">
                                  SubItem : {item.SubItem}{" "}
                                </p>
                                <p className="wcr-card-text">
                                  ItemType : {item.ItemType}{" "}
                                </p>
                                <p className="wcr-card-text">
                                  ItemCode : {item.ItemCode}{" "}
                                </p>
                                <p className="wcr-card-text">
                                  Serial Num /Lot No. : {item.SerialNumber}{" "}
                                </p>
                                <p className="wcr-card-text">
                                  Quantity : {item.Quantity}{" "}
                                </p>

                                <div className="row">
                                  <div className=" col-6 text-center ">
                                    <button
                                      type="submit"
                                      className="btn text-light edit-wcr-btn edit-btn rounded-pill"
                                      onClick={() => navigateToEditEquip(item)}
                                    >
                                      EDIT
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      type="submit"
                                      className="btn text-light bg-dark delete-btn rounded-pill"
                                    //  onClick={redirectToWCR}
                                    >
                                      DELETE
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </form>
              </div>
            )}

            {/* **************CPE MAC toggle******************* */}
            <div
              className="contact-toggle  mt-3"
              onClick={() => handleIconClick("form4")}
            >
              <span className="toggle-text">CPE MAC</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************CPE MAC toggle******************* */}

            {activeForm === "form4" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form4"
              >
                {/*********CPE MAC form******** */}
                <form className="contact-form p-2">
                  <div className="">
                    <label className="select-search-label mt-1">
                      CPE MAC shared
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="state"
                      placeholder=""
                      isSearchable
                      styles={style}
                      value={cpMacShare}
                      onChange={handleSelectCpMacShare}
                      options={optionCpMacShare.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  <div className="text-center mt-4 mb-2">
                    <button className="btn text-light  cpe-save-btn rounded-pill">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* **************General Details toggle******************* */}
            <div
              className="contact-toggle  mt-3"
              onClick={() => handleIconClick("form5")}
            >
              <span className="toggle-text">General Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************General Details toggle******************* */}

            {activeForm === "form5" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form5"
              >
                {/**********General Details form******** */}
                <form className="contact-form p-2">
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].General
                          ? irInfo[0].General.IpAddress
                          : ""
                      }
                    //   onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      IP Address/Subnet Pool :
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].General
                          ? irInfo[0].General.DevicePort
                          : ""
                      }
                    //   onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Device Port No. :
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].General
                          ? irInfo[0].General.First
                          : ""
                      }
                    //   onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      First Usable IP :
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].General
                          ? irInfo[0].General.Last
                          : ""
                      }
                    //   onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Last Usable IP :
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].General
                          ? irInfo[0].General.Subnet
                          : ""
                      }
                    //   onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Subnet Mask :
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].General
                          ? irInfo[0].General.Gateway
                          : ""
                      }
                    //   onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Gateway :
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].General
                          ? irInfo[0].General.Primary
                          : ""
                      }
                    //   onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Primary DNS :
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].General
                          ? irInfo[0].General.Secondary
                          : ""
                      }
                    //   onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Secondary DNS :
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].General
                          ? irInfo[0].General.DeviceId
                          : ""
                      }
                    //   onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Device ID :
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].General
                          ? irInfo[0].General.CPE
                          : ""
                      }
                    //   onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      CPE IP :
                    </label>
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">
                      IR Attached :
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="state"
                      placeholder=""
                      isSearchable
                      styles={style}
                      value={irAttache}
                      onChange={handleSelectIrAttache}
                      options={optionIrAttached.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  <div className="text-center mt-4 mb-2">
                    <button className="btn text-light  cpe-save-btn rounded-pill">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* **************Installation Parameter toggle******************* */}
            <div
              className="contact-toggle  mt-3"
              onClick={() => handleIconClick("form6")}
            >
              <span className="toggle-text">Installation Parameter</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************Installation Parameter toggle******************* */}

            {activeForm === "form6" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form6"
              >
                {/**********Installation Parameter form******** */}
                <form className="contact-form p-2">
                  <div className="">
                    <label className="select-search-label mt-1">
                      Speed test results shown to Customer
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="state"
                      placeholder=""
                      isSearchable={false}
                      styles={style}
                      value={speedTest}
                      onChange={handleSelectSpeedTest}
                      options={optionSpeedTest.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">IP</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="state"
                      placeholder=""
                      isSearchable={false}
                      styles={style}
                      value={selectIP}
                      onChange={handleSelectIP}
                      options={optionIP.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">MRTG</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="state"
                      placeholder=""
                      isSearchable={false}
                      styles={style}
                      value={selectMRTG}
                      onChange={handleSelectMRTG}
                      options={optionMRTG.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">DNS</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="state"
                      placeholder=""
                      isSearchable={false}
                      styles={style}
                      value={selectDns}
                      onChange={handleSelectDns}
                      options={optionDns.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  <div className="">
                    <label
                      className="select-search-label mt-1"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Education customer Regarding SelfCare Portal
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="state"
                      placeholder=""
                      isSearchable={false}
                      styles={style}
                      value={selectSelfcarePortal}
                      onChange={handleSelectSelfcarePortal}
                      options={optionSelfcarePortal.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">
                      Antivirus
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="state"
                      placeholder=""
                      isSearchable={false}
                      styles={style}
                      value={selectAntivirus}
                      onChange={handleSelectAntivirus}
                      options={optionAntivirus.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>
                  {/* Contact Person fields */}
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      className="form-control input-text form-control-sm mt-3"
                      id="cpName"
                      name="cpName"
                      value={cpName}
                      onChange={(e) => setCpName(e.target.value)}
                      placeholder=""
                    />
                    <label htmlFor="cpName" className="mt-2">Contact Person Name</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="tel"
                      className="form-control input-text form-control-sm mt-3"
                      id="cpMobile"
                      name="cpMobile"
                      value={cpMobile}
                      maxLength={10}
                      onKeyDown={(e) => {
                        const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                        const isDigit = /\d/.test(e.key);
                        if (!isDigit && !allowed.includes(e.key)) e.preventDefault();
                        if (isDigit && (e.currentTarget.value || '').length >= 10) e.preventDefault();
                      }}
                      onChange={(e) => setCpMobile(e.target.value.replace(/[^\d]/g, ""))}
                      placeholder=""
                    />
                    <label htmlFor="cpMobile" className="mt-2">Contact Person Mobile Number</label>
                  </div>

                  <div className="mt-3">
                    <label className="select-search-label mt-1">Educated on MRTG</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={educatedOnMRTG}
                      onChange={setEducatedOnMRTG}
                      options={yesNoOptions}
                    />
                  </div>
                  {educatedOnMRTG.value === "111260000" && (
                    <div className="input-box form-floating" style={{ position: "relative" }}>
                      <input
                        id="educMRTGImg"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageUpload(e, setEducatedOnMRTGImg)}
                        style={{ display: "none" }}
                      />
                      <input
                        type="text"
                        className="form-control input-text form-control-sm mt-1"
                        value={educatedOnMRTGImg.fileNameWithExtension}
                        placeholder="Upload Image"
                        readOnly
                        onClick={() => document.getElementById("educMRTGImg").click()}
                      />
                      <i
                        className="fa-solid fa-paperclip paperclip-icon"
                        onClick={() => document.getElementById("educMRTGImg").click()}
                      ></i>
                      <label className="paperclip mt-2">Upload Image</label>
                    </div>
                  )}

                  {/* Informed customer end user about contention ratio */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">Informed customer end user about contention ratio</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={informedCustomerContentionRatio}
                      onChange={setInformedCustomerContentionRatio}
                      options={yesNoOptions}
                    />
                  </div>

                  {/* Pasted Sticker on CPE */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">Pasted Sticker on CPE</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={pastedStickerOnCPE}
                      onChange={setPastedStickerOnCPE}
                      options={yesNoOptions}
                    />
                  </div>

                  {/* Educated customer on Welcome Mailer */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">Educated customer on Welcome Mailer</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={educatedCustomerWelcomeMailer}
                      onChange={setEducatedCustomerWelcomeMailer}
                      options={yesNoOptions}
                    />
                  </div>

                  {/* Educated Customer on FLT Steps */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">Educated Customer on FLT Steps</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={educatedCustomerOnFLTSteps}
                      onChange={setEducatedCustomerOnFLTSteps}
                      options={yesNoOptions}
                    />
                  </div>

                  {/* Mount Rack on Wall with proper hardware */}
                  {/* <div className="mt-3">
                    <label className="select-search-label mt-1">Mount Rack on Wall with proper hardware</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={mountRackOnWallProperHardware}
                      onChange={setMountRackOnWallProperHardware}
                      options={yesNoOptions}
                    />
                  </div> */}
                  {/* {mountRackOnWallProperHardware.value === "111260000" && (
                    <div className="input-box form-floating" style={{ position: "relative" }}>
                      <input
                        id="mountRackImg"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageUpload(e, setMountRackImage)}
                        style={{ display: "none" }}
                      />
                      <input
                        type="text"
                        className="form-control input-text form-control-sm mt-1"
                        value={mountRackImage.fileNameWithExtension}
                        placeholder="Upload Image"
                        readOnly
                        onClick={() => document.getElementById("mountRackImg").click()}
                      />
                      <i
                        className="fa-solid fa-paperclip paperclip-icon"
                        onClick={() => document.getElementById("mountRackImg").click()}
                      ></i>
                      <label className="paperclip mt-2">Upload Image</label>
                    </div>
                  )} */}

                  {/* Mount D-Link/Switch/ONT at suitable height */}
                  {/* <div className="mt-3">
                    <label className="select-search-label mt-1">Mount D-Link/Switch/ONT at suitable height</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={mountDLinkSwitchONT}
                      onChange={setMountDLinkSwitchONT}
                      options={yesNoOptions}
                    />
                  </div>
                  {mountDLinkSwitchONT.value === "111260000" && (
                    <div className="input-box form-floating" style={{ position: "relative" }}>
                      <input
                        id="mountDLinkImg"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageUpload(e, setMountDLinkImage)}
                        style={{ display: "none" }}
                      />
                      <input
                        type="text"
                        className="form-control input-text form-control-sm mt-1"
                        value={mountDLinkImage.fileNameWithExtension}
                        placeholder="Upload Image"
                        readOnly
                        onClick={() => document.getElementById("mountDLinkImg").click()}
                      />
                      <i
                        className="fa-solid fa-paperclip paperclip-icon"
                        onClick={() => document.getElementById("mountDLinkImg").click()}
                      ></i>
                      <label className="paperclip mt-2">Upload Image</label>
                    </div>
                  )} */}

<div className="mt-3">
                    <label className="select-search-label mt-1">
                      Mount Rack on Wall with proper hardware (Image)*
                    </label>
                    <div className="input-box form-floating" style={{ position: "relative" }}>
                      <input
                        id="mountRackImg"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageUpload(e, setMountRackImage)}
                        style={{ display: "none" }}
                      />
                      <input
                        type="text"
                        className="form-control input-text form-control-sm mt-1"
                        value={mountRackImage.fileNameWithExtension}
                        placeholder="Upload Image"
                        readOnly
                        onClick={() => document.getElementById("mountRackImg").click()}
                      />
                      <i
                        className="fa-solid fa-paperclip paperclip-icon"
                        onClick={() => document.getElementById("mountRackImg").click()}
                      ></i>
                      <label className="paperclip mt-2">Upload Image</label>
                    </div>
                  </div>
                  {/* Mount D-Link/Switch/ONT at suitable height - Image only (mandatory) */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">
                      Mount D-Link/Switch/ONT at suitable height (Image)*
                    </label>
                    <div className="input-box form-floating" style={{ position: "relative" }}>
                      <input
                        id="mountDLinkImg"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageUpload(e, setMountDLinkImage)}
                        style={{ display: "none" }}
                      />
                      <input
                        type="text"
                        className="form-control input-text form-control-sm mt-1"
                        value={mountDLinkImage.fileNameWithExtension}
                        placeholder="Upload Image"
                        readOnly
                        onClick={() => document.getElementById("mountDLinkImg").click()}
                      />
                      <i
                        className="fa-solid fa-paperclip paperclip-icon"
                        onClick={() => document.getElementById("mountDLinkImg").click()}
                      ></i>
                      <label className="paperclip mt-2">Upload Image</label>
                    </div>
                  </div>

                  {/* Drop/OFC cable to be properly routed to FTB */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">Drop/OFC cable to be properly routed to FTB</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={dropOFCCableFTB}
                      onChange={setDropOFCCableFTB}
                      options={yesNoOptions}
                    />
                  </div>

                  {/* No sharp bend for drop cable / OFC cable */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">No sharp bend for drop cable / OFC cable</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={noSharpBendDropCableOFCcable}
                      onChange={setNoSharpBendDropCableOFCcable}
                      options={yesNoOptions}
                    />
                  </div>

                  {/* P-clamp to be fixed after every 0.5 meters */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">P-clamp to be fixed after every 0.5 meters</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={pClampFixedAfterEveryMeters}
                      onChange={setPClampFixedAfterEveryMeters}
                      options={yesNoOptions}
                    />
                  </div>

                  {/* Leftover material cleared post wiring completion */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">Leftover material cleared post wiring completion</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={allMaterialWiringCompletion}
                      onChange={setAllMaterialWiringCompletion}
                      options={yesNoOptions}
                    />
                  </div>

                  {/* ONT Provisioning */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">ONT Provisioning</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={ONTProvisioning}
                      onChange={setONTProvisioning}
                      options={yesNoOptions}
                    />
                  </div>

                  {/* Switch Provisioning */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">Switch Provisioning</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={SwitchProvisioning}
                      onChange={setSwitchProvisioning}
                      options={yesNoOptions}
                    />
                  </div>

                  {/* Redundancy Failover */}
                  <div className="mt-3">
                    <label className="select-search-label mt-1">Redundancy Failover</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      isSearchable={false}
                      styles={style}
                      value={redundancyFailoverCheck}
                      onChange={setRedundancyFailoverCheck}
                      options={yesNoOptions}
                    />
                  </div>
                  {redundancyFailoverCheck.value === "111260000" && (
                    <div className="input-box form-floating" style={{ position: "relative" }}>
                      <input
                        id="redundancyFailoverImg"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageUpload(e, setRedundancyFailoverImage)}
                        style={{ display: "none" }}
                      />
                      <input
                        type="text"
                        className="form-control input-text form-control-sm mt-1"
                        value={redundancyFailoverImage.fileNameWithExtension}
                        placeholder="Upload Image"
                        readOnly
                        onClick={() => document.getElementById("redundancyFailoverImg").click()}
                      />
                      <i
                        className="fa-solid fa-paperclip paperclip-icon"
                        onClick={() => document.getElementById("redundancyFailoverImg").click()}
                      ></i>
                      <label className="paperclip mt-2">Upload Image</label>
                    </div>
                  )}

                  {/* Save button */}
                  <div className="text-center mt-4 mb-2">
                    <button
                      type="button"
                      className="btn text-light cpe-save-btn rounded-pill"
                      onClick={handleSaveInstallationParams}
                    >
                      Save
                    </button>
                  </div>
                  {/* <div className="text-center mt-4 mb-2">
                    <button className="btn text-light  cpe-save-btn rounded-pill">
                      Save
                    </button>
                  </div> */}
                </form>
              </div>
            )}

            {/* **************Engineer Details toggle******************* */}
            <div
              className="contact-toggle  mt-3"
              onClick={() => handleIconClick("form7")}
            >
              <span className="toggle-text">Engineer Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************Engineer Details toggle******************* */}

            {activeForm === "form7" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form7"
              >
                {/**********Engineer Details form******** */}
                <form className="contact-form p-2">
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="businessSegment"
                      value={
                        irInfo.length > 0 && irInfo[0].Engineer
                          ? irInfo[0].Engineer.EngName
                          : ""
                      }
                    // onChange="{handleChange}"
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Engineer Name
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="tel"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="installationCode"
                      name="installationCode"
                      maxLength="6"
                      pattern="[0-9]{10}"
                      value={userIrData.installationCode}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        const isDigit = /\d/.test(e.key);
                        if (
                          (isDigit || allowedKeys.includes(e.key)) &&
                          (userIrData.installationCode.length < 6 || e.key === "Backspace")
                        ) {
                          return true;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Installation Code :
                    </label>
                  </div>

                  {/* {console.log(
                    "userIrData.installationdate",
                    userIrData.installationdate
                  )} */}
                  <div className="input-box form-floating">
                    <input
                      type="date"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="installationdate"
                      name="installationdate"
                      value={userIrData.installationdate}

                      min={getCurrentDate()}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Installation Date :
                    </label>
                  </div>

                  <div className="text-center mt-4 mb-2">
                    <button className="btn text-light  cpe-save-btn rounded-pill">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* **************Service Consumption toggle******************* */}
            <div
              className="contact-toggle  mt-3"
              onClick={() => handleIconClick("form8")}
            >
              <span className="toggle-text">Service Consumption</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************Service Consumption toggle******************* */}
            {activeForm === "form8" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form8"
              >
                <div className="col text-center ">
                  <button
                    type="button"
                    className="btn text-light mt-2 mb-3 w-75 add-item-btn mx-auto"

                    onClick={redirectServiceConsumptionIR}

                  >
                    ADD SERVICE
                  </button>
                </div>
                {/**********Service Consumption******** */}
                <form className="contact-form p-2">
                  {irInfo?.map((ir, index) => (
                    <div className="form-floating" key={index}>
                      {ir?.serviceConsumtionList?.map((item, itemIndex) => (
                        <div className="col" key={itemIndex}>
                          <div className="card mb-3">
                            <div className="m-2 card-data ">
                              <div>
                                <p className="wcr-card-text">
                                  Item : {item.Item}
                                </p>
                                <p className="wcr-card-text">
                                  SubItem : {item.SubItem}{" "}
                                </p>
                                <p className="wcr-card-text">
                                  ItemType : {item.ItemType}{" "}
                                </p>
                                <p className="wcr-card-text">
                                  ItemCode : {item.ItemCode}{" "}
                                </p>
                                <p className="wcr-card-text">
                                  Quantity : {item.Quantity}{" "}
                                </p>

                                <div className="row">
                                  <div className=" col-6 text-center ">
                                    <button
                                      type="submit"
                                      className="btn text-light edit-wcr-btn edit-btn rounded-pill"
                                      onClick={() => navigateToServiceConsumption(item)}
                                    >
                                      EDIT
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      type="submit"
                                      className="btn text-light bg-dark delete-btn rounded-pill"
                                    //  onClick={redirectToWCR}
                                    >
                                      DELETE
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </form>
              </div>
            )}

            {/* **************On Hold toggle******************* */}
            <div
              className="contact-toggle  mt-3"
              onClick={() => handleIconClick("form9")}
            >
              <span className="toggle-text">On Hold</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************On Hold toggle******************* */}

            {activeForm === "form9" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form9"
              >
                {/**********On Hold form******** */}
                <form className="contact-form p-2">
                  <div className="">
                    <label className="select-search-label mt-1">
                      Hold Category
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="state"
                      placeholder="Hold Category"
                      styles={style}
                      isSearchable={false}
                      value={selectHoldCategory}
                      onChange={handleSelectHoldCategory}
                      options={holdCategories}
                    />
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="holdReason"
                      name="holdReason"
                      value={userIrData.holdReason}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Hold Reason :
                    </label>
                  </div>

                  <div className="text-center mt-4 mb-2">
                    <button className="btn text-light  cpe-save-btn rounded-pill">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* **************Remarks toggle******************* */}
            <div
              className="contact-toggle  mt-3"
              onClick={() => handleIconClick("form10")}
            >
              <span className="toggle-text">Remarks</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************Remarks toggle******************* */}

            {activeForm === "form10" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form10"
              >
                {/**********Remarks  form******** */}
                <form className="contact-form p-2">
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="remark"
                      name="remark"
                      value={userIrData.remark}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Remarks :
                    </label>
                  </div>
                </form>
              </div>
            )}

            {/* **************Attachments toggle******************* */}
            <div
              className="contact-toggle  mt-3"
              onClick={() => handleAttachmentClick("form11")}
            >
              <span className="toggle-text">Attachments</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {/* **************Attachments toggle******************* */}

            {attachForm === "form11" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form11"
              >
                {/**********Attachments form******** */}
                <form className="contact-form p-2">
                  <div
                    className="input-box form-floating"
                    style={{ position: "relative" }}
                  >
                    <input
                      id="cameraFileInput"
                      type="file"
                      accept="image/*"
                      capture="environment"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="picture"
                      name="picture"
                      value={fileName}
                      accept="image/*"
                      capture="environment"
                      style={{ background: "transparent" }}
                      onClick={openCamera}
                      readOnly
                    />
                    <i
                      className="fa-solid fa-camera fa-camera-icon"
                      onClick={openCamera}
                    ></i>
                    <label htmlFor="floatingInput" className="paperclip mt-2">
                      Capture Image
                    </label>
                  </div>
                  {loaders ? (
                    <div className="loader-wrap">
                      <div className="loader text-center">
                        <img src={loader} alt="loading...." />
                      </div>
                    </div>
                  ) : (
                    documentfile &&
                    documentfile.map((item, index) => (
                      <div className="row image-contain m-1" key={index}>
                        <div className="col-10 mb-1">
                          <span>{item.Filename}</span>
                        </div>
                        <div className="col-2 mb-1">
                          <span
                            className="icon-wrapper"
                            onClick={() =>
                              handleDownload(item.Filename, item.Attachment)
                            }
                          >
                            <i className="fa-solid fa-arrow-down"></i>
                          </span>
                        </div>
                      </div>
                    ))
                  )}
                </form>
              </div>
            )}

            <div className=" text-center mt-5 mb-3">
              <button
                type="submit"
                className="btn text-light ir-btn mx-auto rounded-pill"
              // onClick=""
              >
                IR
              </button>
            </div>

            <div className=" text-center mt-5 mb-5">
              <button
                type="submit"
                className="btn text-light approval-btn mx-auto rounded-pill"
              // onClick=""
              >
                Submit for Approval
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InstallationIR;
